<script>
import store from '@state/store'
import { formatPhoneNumber } from '@utils/phone-format'
import { DateTime } from 'luxon'

export default {
  components: {},
  data() {
    return {
      loaded: false,
      figment: null,
    }
  },
  mounted() {
    this.figment = store.getters['figments/selectedFigment']
    this.loaded = true
  },
  methods: {
    format: formatPhoneNumber,
    formatDate(date) {
      return DateTime.fromISO(date).toFormat('MMMM dd, yyyy')
    },
    doCopy(text) {
      this.$copyText(text).then(
        () => {
          this.$notification.success({
            message: `Field Copied!`,
            duration: 2,
          })
        },
        () => {
          this.$notification.error({
            message: `Failed to Copy`,
            duration: 2,
          })
        }
      )
    },
  },
}
</script>

<template>
  <div class="sms--container">
    <div v-if="!loaded" class="loader">
      <a-icon
        type="loading"
        style="padding-left: 8px; font-size: 24px; color: #1890ff"
        spin
      />
    </div>
    <div v-else>
      <a-card style="width: 100%">
        <a-row>
          <a-descriptions
            v-if="figment.meta.sims"
            title="SIM Data"
            bordered
            :column="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }"
          >
            <a-descriptions-item label="MTN #">
              {{ format(figment.meta.sims.pk.replace('SIM#', '')) }}
              <a-button
                size="small"
                shape="circle"
                @click="
                  doCopy(format(figment.meta.sims.pk.replace('SIM#', '')))
                "
              >
                <a-icon type="copy" />
              </a-button>
            </a-descriptions-item>

            <a-descriptions-item label="Hardware Id">
              {{ figment.meta.sims.hardwareId }}
              <a-button
                size="small"
                shape="circle"
                @click="doCopy(figment.meta.sims.hardwareId)"
              >
                <a-icon type="copy" />
              </a-button>
            </a-descriptions-item>
          </a-descriptions>
        </a-row>
      </a-card>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

.loader {
  padding: 2rem;
  text-align: center;
}

.button--container {
  width: 100%;
  margin-top: 8px;

  button {
    width: 100%;
  }
}

.form--container {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: white;
}

.sms--container {
  height: 100%;
  overflow-y: scroll;
  button.ant-btn.ant-btn-circle.ant-btn-sm {
    float: right;
  }
}
</style>
